import React, { useState } from "react";
import { Card, IconButton, TooltipIcon, usePrefersReducedMotion, } from "@sscs/ui";
import { ReplayIcon } from "@sscs/ui/icons";
import { motion } from "framer-motion";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import DiamondTooltip from "./LevelDiamond/DiamondTooltip";
import LevelDiamond from "./LevelDiamond/LevelDiamond";
import LevelLine from "./LevelLine/LevelLine";
import styles from "./levels.module.scss";
export const ANIMATION_STAGGER = 0.25;
const LEVELS = [1, 2, 3, 4, 5];
const Animation = ({ inhibitors, lineLabelWrapper, renderDiamondTooltip, levelsInfo, }) => {
    const prefersReducedMotion = usePrefersReducedMotion();
    const [triggerReplay, setTriggerReplay] = useState(0);
    // For propagation to work, children variants need to have the same
    // keys for initial and animate
    // Parent is used just to trigger children animation which is why
    // opacity doesn't change between start and end
    const parentVariant = {
        start: { opacity: 1 },
        end: {
            opacity: 1,
            transition: {
                staggerChildren: ANIMATION_STAGGER,
                when: "beforeChildren",
                delay: triggerReplay > 0 ? 0 : 0.35,
            },
        },
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(motion.div, { initial: prefersReducedMotion ? false : "start", animate: "end", variants: parentVariant, className: styles.levels, 
            // Different key will cause remount thus replaying animation
            // It is simpler than manually setting and starting animations
            key: triggerReplay },
            React.createElement("div", { className: styles.start }),
            LEVELS.map((level) => {
                var _a;
                return (React.createElement(React.Fragment, { key: `level-${level}` },
                    React.createElement(LevelLine, { level: level, inhibitors: inhibitors, improvementsText: inhibitors.requirements[level] ? (React.createElement(RenderChildrenWrapper, { wrapper: lineLabelWrapper &&
                                ((children) => lineLabelWrapper(level, children)) },
                            "Fix",
                            " ",
                            React.createElement("strong", null, (_a = inhibitors.requirements[level]) === null || _a === void 0 ? void 0 : _a.toLocaleString()),
                            " ",
                            "Issues")) : (React.createElement("span", { className: styles["no-blockers"] }, "No blockers")) }),
                    React.createElement(LevelDiamond, { level: level, inhibitors: inhibitors, tooltipTitle: renderDiamondTooltip ? renderDiamondTooltip(level) : undefined, levelsInfo: levelsInfo })));
            })),
        React.createElement("div", { className: styles.info },
            "Hover over levels for more information",
            !prefersReducedMotion && (React.createElement(IconButton, { tooltipTitle: "Replay animation", onClick: () => setTriggerReplay((prev) => prev + 1) },
                React.createElement(ReplayIcon, null))))));
};
const LevelsPanel = ({ inhibitors, children, }) => {
    if (inhibitors.scan_level === 0)
        return null;
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                React.createElement(TooltipIcon, { key: "tooltip", size: "xs", title: React.createElement(React.Fragment, null,
                        "SAFE Levels provide a guided approach to improving overall software quality by pointing developers to key software safety concerns.",
                        inhibitors.customized && (React.createElement("div", { className: styles["tooltip-custom-levels"] }, "One or more failing conditions are suppressed by user override."))) }),
            ] }, `SAFE Levels ${inhibitors.customized ? "(Customized)" : ""}`),
        React.createElement(Card.Content, null, children)));
};
export default {
    Panel: LevelsPanel,
    Animation,
    DiamondTooltip,
};
//# sourceMappingURL=Levels.js.map